<app-nav></app-nav>
<Section class="submission" *ngIf="!submissionSuccessfull">
  <!-- view card starts -->
  <div class="modal-container-vm ">
    <div class="modal-overlay-vm"></div>
    <div class="modal-card-vm">
      <p class="sub-title mt-4">Registered Claims</p>
      <div class="border rounded claimCards pt-2 content-box mt-4">
        <div class="row">
          <div class="col-6">
            <div class="row cardFields">Patient Name</div>
            <div class="row cardFieldsVal">{{this.claimant}}</div>
          </div>
          <div class="col-6">
            <span class="row cardFields">Claimant</span>
            <span class="row cardFieldsVal">{{this.employeeName}}</span>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <div class="row cardFields">Date</div>
            <div class="row cardFieldsVal">{{this.registeredDate | date : 'dd/MM/yyyy'}}</div>
          </div>
          <div class="col-6">
            <div class="row cardFields">Registration No.</div>
            <div class="row cardFieldsVal">{{this.intimationNo}}</div>
          </div>
        </div>
        <button type="button" class="btn-pdf row cardFieldsVal" id="viewMoreEclaimsButton" (click)="viewDetails();">
          View Details
        </button>
        <!-- expanded -->
        <div id="viewMoreEclaimsData" hidden>
          <div class="row mt-4">
            <div class="col-6">
              <div class="row cardFields">Type of Policy</div>
              <div class="row cardFieldsVal">{{this.productType}}</div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <span class="row cardFields">Insurer</span>
              <span class="row cardFieldsVal">{{this.insurer}}</span>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <div class="row cardFields">Treatment For</div>
              <div class="row cardFieldsVal">{{this.ailment}}</div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="row cardFields">Email</div>
              <div class="row cardFieldsVal">{{this.email}}</div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="row cardFields">Policy No.</div>
              <div class="row cardFieldsVal">{{this.policyNumber}}</div>
            </div>
            <div class="col-6">
              <div class="row cardFields">Card No.</div>
              <div class="row cardFieldsVal">{{this.cardNumber}}</div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="row cardFields">Mobile No.</div>
              <div class="row cardFieldsVal">{{this.mobileNo}}</div>
            </div>
            <div class="col-6">
              <div class="row cardFields">Relation with Claimant</div>
              <div class="row cardFieldsVal">{{this.relationWithEmployee}}</div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="row cardFields">Estimated Amount</div>
              <div class="row cardFieldsVal">{{this.estimatedAmount}}</div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="row cardFields">Admission Date</div>
              <div class="row cardFieldsVal">{{this.admissionDate  | date : 'dd/MM/yyyy'}}</div>
            </div>
            <div class="col-6">
              <div class="row cardFields">Discharge Date</div>
              <div class="row cardFieldsVal">{{this.dischargeDate  | date : 'dd/MM/yyyy'}}</div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="row cardFields">Hospital State</div>
              <div class="row cardFieldsVal">{{this.hospitalState}}</div>
            </div>
            <div class="col-6">
              <div class="row cardFields">Hospital City</div>
              <div class="row cardFieldsVal">{{this.hospitalCity}}</div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <div class="row cardFields">Hospital Name</div>
              <div class="row cardFieldsVal">{{this.hospitalName}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- expanded -->
      <div class="spacer"></div>
      <div class="col">
        <p class="sub-title mt-2">Download</p>
        <div class="row">
          <div class="col-6">
            <div *ngIf="this.claimsFormRepoId; else notFound">
              <a type="button" class="btn-pdf row cardFieldsVal" target="_blank" (click)="downloadClaimForm()">
                <img class="claim-form"
                  src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/claim-form.svg">
                <label for="text" class="downloadLable"> Claim Form</label>
              </a>
            </div>
            <ng-template #notFound>
              <p>Form Not Available. Please contact <a href="mailto:support@securenow.in">support@securenow.in</a></p>
            </ng-template>
          </div>
          <div class="spacerVer"></div>
          <div class="col-6">
            <a type="button" class="btn-pdf row cardFieldsVal" target="_blank"
              href="https://static-files-website.s3.ap-south-1.amazonaws.com/Checklist+doc.pdf">
              <img class="pdf-icon"
                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/pdf-icon.svg">
              <label for="text" class="downloadLable">Check List</label>
            </a>
          </div>
        </div>
      </div>

      <div class="spacer"></div>
      <p class="sub-title mt-4">Upload Document Proof</p>
      <span class="note row">Note: Maximum size of each file is 50 MB </span>
      <span id="snackbar"></span>
      <ul class="product-list">

<li id="accordion">
  <div>
   <div class="card">
      <div class="card-header">
        <a class="collapsed card-link" data-toggle="collapse" href="#buyCollapse1">
          1. Claim Form
        </a>
      </div>
      <div id="buyCollapse1" class="collapse" data-parent="#accordion">
        <div class="card-body">
          <div class="sum-insured-input">
            <div class="form-group">
              <input id="file" style="display: none" type="file" multiple
              (change)="claimForm($event.target.files)" #fileInput ng2FileSelect
              accept="image/x-png,image/jpeg,.png,image/jpg,.zip,.pdf,.doc,.dox,.xls,.xlsx"
              [uploader]="uploader" multiple required>
              <img class="attachment-icon" (click)="fileInput.click()">
                <label>Attach Files</label>
                <div class="mt-2">
                  <div class="" *ngIf="uploading">
                    <span class="spinner-border spinner-border-sm text-info"></span>
                    Uploading..
                  </div>
                  <div id="previouslyUploadedClaimForm" hidden>
                    <label for="text" style="font: bold; color: #438BC9;">Previously Uploaded </label>
                      <div class="attachedFiles" *ngFor='let docs of cliamDocuments, let index = index'>
                       <ng-container *ngIf="docs.documentId==1">
                        <li>{{docs.docDescription}} <button class="btnDeleteFile" id="{{docs.id}}"
                        (click)="deleteDocByClaimDocumentId(docs.id, index)"></button></li>
                      </ng-container>
                      </div>
                  </div>
                  <div class="attachmentList" *ngFor="let name of fileNameArray;  let i = index" [attr.data-index]="i">
                    <li>{{name}} <button class="btnDeleteFile" (click)="removeSelectedFile(i, 'claimForm')"></button></li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  <div class="card">
    <div class="card-header">
      <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwo">
        2. Hospital Bill and Medicine Bill
      </a>
    </div>
    <div id="collapseTwo" class="collapse" data-parent="#accordion">
      <div class="card-body">
        <div class="sum-insured-input">
          <div class="form-group">

            <input id="addAttachment" style="display: none" type="file" (change)="hospitalBill($event.target.files)"
              #fileInputTwo ng2FileSelect accept="image/x-png,image/jpeg,.png,image/jpg,.zip,.pdf,.doc,.dox,.xls,.xlsx"
              [uploader]="uploader" multiple required>
            <img class="attachment-icon" (click)="fileInputTwo.click()">
            <label>Attach Files</label>
            <div class="mt-2">
              <div class="" *ngIf="uploading">
                <span class="spinner-border spinner-border-sm text-info"></span>
                Uploading..
              </div>
              <div id="previouslyUploadedHospitalBills" hidden>
                <label for="text" style="font: bold; color: #438BC9;">Previously Uploaded </label>
                <div class="attachedFiles" *ngFor='let docs of cliamDocuments'>
                  <ng-container *ngIf="docs.documentId==2">
                    <li>{{docs.docDescription}} <button class="btnDeleteFile" id="{{docs.id}}"
                        (click)="deleteDocByClaimDocumentId(docs.id)"></button></li>
                  </ng-container>
                </div>
              </div>
              <div class="attachmentList" *ngFor="let bills of hospitalBills;  let i = index" [attr.data-index]="i">
                <li>{{bills}} <button class="btnDeleteFile" (click)="removeSelectedFile(i, 'bill')"></button></li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <a class="collapsed card-link" data-toggle="collapse" href="#collapseThree">
        3. Doctor's Prescription
      </a>
    </div>
    <div id="collapseThree" class="collapse" data-parent="#accordion">
      <div class="card-body">
        <div class="sum-insured-input">
          <div class="form-group">

            <input id="addAttachment" style="display: none" type="file"
              (change)="doctorsPrescription($event.target.files)" #fileInputThree ng2FileSelect
              accept="image/x-png,image/jpeg,.png,image/jpg,.zip,.pdf,.doc,.dox,.xls,.xlsx" [uploader]="uploader"
              multiple required>
            <img class="attachment-icon" (click)="fileInputThree.click()">
            <label>Attach Files</label>
            <div class="mt-2">
              <div class="" *ngIf="uploading">
                <span class="spinner-border spinner-border-sm text-info"></span>
                Uploading..
              </div>
              <div id="previouslyUploadedDoctorsPrescription" hidden>
                <label for="text" style="font: bold; color: #438BC9;">Previously Uploaded </label>
                <div class="attachedFiles" *ngFor='let docs of cliamDocuments'>
                  <ng-container *ngIf="docs.documentId==3">
                    <li>{{docs.docDescription}} <button class="btnDeleteFile" id="{{docs.id}}"
                        (click)="deleteDocByClaimDocumentId(docs.id)"></button></li>
                  </ng-container>
                </div>
              </div>
              <div class="attachmentList" *ngFor="let prescription of doctorsPresriptions;  let i = index"
                [attr.data-index]="i">
                <li>{{prescription}} <button class="btnDeleteFile"
                    (click)="removeSelectedFile(i, 'prescriptions')"></button></li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header border-btm-0">
      <a class="collapsed card-link" data-toggle="collapse" href="#collapseFour">
        4. Paid Receipts
      </a>
    </div>
    <div id="collapseFour" class="collapse" data-parent="#accordion">
      <div class="card-body">
        <div class="sum-insured-input">
          <div class="form-group">

            <input id="addAttachment" style="display: none" type="file" (change)="paidReceipt($event.target.files)"
              #fileInputFour ng2FileSelect accept="image/x-png,image/jpeg,.png,image/jpg,.zip,.pdf,.doc,.dox,.xls,.xlsx"
              [uploader]="uploader" multiple required>
            <img class="attachment-icon" (click)="fileInputFour.click()">
            <label>Attach Files</label>
            <div class="mt-2">
              <div class="" *ngIf="uploading">
                <span class="spinner-border spinner-border-sm text-info"></span>
                Uploading..
              </div>
              <div id="previouslyUploadedPaidReciepts" hidden>
                <label for="text" style="font: bold; color: #438BC9;">Previously Uploaded </label>
                <div class="attachedFiles" *ngFor='let docs of cliamDocuments'>
                  <ng-container *ngIf="docs.documentId==4">
                    <li>{{docs.docDescription}} <button class="btnDeleteFile" id="{{docs.id}}"
                        (click)="deleteDocByClaimDocumentId(docs.id)"></button></li>
                  </ng-container>
                </div>
              </div>
              <div class="attachmentList" *ngFor="let receipts of paidRecipts;  let i = index" [attr.data-index]="i">
                <li>{{receipts}} <button class="btnDeleteFile" (click)="removeSelectedFile(i, 'receipt')"></button></li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <a class="collapsed card-link" data-toggle="collapse" href="#collapseFive">
        5. Diagnostic Reports
      </a>
    </div>
    <div id="collapseFive" class="collapse" data-parent="#accordion">
      <div class="card-body">
        <div class="sum-insured-input">
          <div class="form-group">

            <input id="addAttachment" style="display: none" type="file" (change)="diagnosticReport($event.target.files)"
              #fileInputFive ng2FileSelect accept="image/x-png,image/jpeg,.png,image/jpg,.zip,.pdf,.doc,.dox,.xls,.xlsx"
              [uploader]="uploader" multiple required>
            <img class="attachment-icon" (click)="fileInputFive.click()">
            <label>Attach Files</label>
            <div class="mt-2">
              <div class="" *ngIf="uploading">
                <span class="spinner-border spinner-border-sm text-info"></span>
                Uploading..
              </div>
              <div id="previouslyUploadedDiagnosticReports" hidden>
                <label for="text" style="font: bold; color: #438BC9;">Previously Uploaded </label>
                <div class="attachedFiles" *ngFor='let docs of cliamDocuments'>
                  <ng-container *ngIf="docs.documentId==5">
                    <li>{{docs.docDescription}} <button class="btnDeleteFile" id="{{docs.id}}"
                        (click)="deleteDocByClaimDocumentId(docs.id)"></button></li>
                  </ng-container>
                </div>
              </div>
              <div class="attachmentList" *ngFor="let reports of diagnosticReports;  let i = index"
                [attr.data-index]="i">
                <li>{{reports}} <button class="btnDeleteFile" (click)="removeSelectedFile(i, 'report')"></button></li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <a class="collapsed card-link" data-toggle="collapse" href="#collapseSix">
        6. Implant Stickers
      </a>
    </div>
    <div id="collapseSix" class="collapse" data-parent="#accordion">
      <div class="card-body">
        <div class="sum-insured-input">
          <div class="form-group">

            <input id="addAttachment" style="display: none" type="file" (change)="implantSticker($event.target.files)"
              #fileInputSix ng2FileSelect accept="image/x-png,image/jpeg,.png,image/jpg,.zip,.pdf,.doc,.dox,.xls,.xlsx"
              [uploader]="uploader" multiple required>
            <img class="attachment-icon" (click)="fileInputSix.click()">
            <label>Attach Files</label>
            <div class="mt-2">
              <div class="" *ngIf="uploading">
                <span class="spinner-border spinner-border-sm text-info"></span>
                Uploading..
              </div>
              <div id="previouslyUploadedImplantStickers" hidden>
                <label for="text" style="font: bold; color: #438BC9;">Previously Uploaded </label>
                <div class="attachedFiles" *ngFor='let docs of cliamDocuments'>
                  <ng-container *ngIf="docs.documentId==6">
                    <li>{{docs.docDescription}} <button class="btnDeleteFile" id="{{docs.id}}"
                        (click)="deleteDocByClaimDocumentId(docs.id)"></button></li>
                  </ng-container>
                </div>
              </div>
              <div class="attachmentList" *ngFor="let stickers of implantStickers;  let i = index"
                [attr.data-index]="i">
                <li>{{stickers}} <button class="btnDeleteFile" (click)="removeSelectedFile(i, 'sticker')"></button></li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <a class="collapsed card-link" data-toggle="collapse" href="#collapseSeven">
        7. NEFT Details (Cancelled Cheques)
      </a>
    </div>
    <div id="collapseSeven" class="collapse" data-parent="#accordion">
      <div class="card-body">
        <div class="sum-insured-input">
          <div class="form-group">

            <input id="addAttachment" style="display: none" type="file" (change)="neftDetail($event.target.files)"
              #fileInputSeven ng2FileSelect
              accept="image/x-png,image/jpeg,.png,image/jpg,.zip,.pdf,.doc,.dox,.xls,.xlsx" [uploader]="uploader"
              multiple required>
            <img class="attachment-icon" (click)="fileInputSeven.click()">
            <label>Attach Files</label>
            <div class="mt-2">
              <div class="" *ngIf="uploading">
                <span class="spinner-border spinner-border-sm text-info"></span>
                Uploading..
              </div>
              <div id="previouslyUploadedNefts" hidden>
                <label for="text" style="font: bold; color: #438BC9;">Previously Uploaded </label>
                <div class="attachedFiles" *ngFor='let docs of cliamDocuments'>
                  <ng-container *ngIf="docs.documentId==7">
                    <li>{{docs.docDescription}} <button class="btnDeleteFile" id="{{docs.id}}"
                        (click)="deleteDocByClaimDocumentId(docs.id)"></button></li>
                  </ng-container>
                </div>
              </div>
              <div class="attachmentList" *ngFor="let nefts of neftDetails;  let i = index" [attr.data-index]="i">
                <li>{{nefts}} <button class="btnDeleteFile" (click)="removeSelectedFile(i, 'neft')"></button></li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <a class="collapsed card-link" data-toggle="collapse" href="#collapseEight">
        8. Discharge Summary
      </a>
    </div>
    <div id="collapseEight" class="collapse" data-parent="#accordion">
      <div class="card-body">
        <div class="sum-insured-input">
          <div class="form-group">

            <input id="addAttachment" style="display: none" type="file" (change)="dischargeDetail($event.target.files)"
              #fileInputEight ng2FileSelect
              accept="image/x-png,image/jpeg,.png,image/jpg,.zip,.pdf,.doc,.dox,.xls,.xlsx" [uploader]="uploader"
              multiple required>
            <img class="attachment-icon" (click)="fileInputEight.click()">
            <label>Attach Files</label>
            <div class="mt-2">
              <div class="" *ngIf="uploading">
                <span class="spinner-border spinner-border-sm text-info"></span>
                Uploading..
              </div>
              <div id="previouslyUploadedDischargeSummary" hidden>
                <label for="text" style="font: bold; color: #438BC9;">Previously Uploaded </label>
                <div class="attachedFiles" *ngFor='let docs of cliamDocuments'>
                  <ng-container *ngIf="docs.documentId==8">
                    <li>{{docs.docDescription}} <button class="btnDeleteFile" id="{{docs.id}}"
                        (click)="deleteDocByClaimDocumentId(docs.id)"></button></li>
                  </ng-container>
                </div>
              </div>
              <div class="attachmentList" *ngFor="let summary of dischargeSummaryDetails;  let i = index"
                [attr.data-index]="i">
                <li>{{summary}}<button class="btnDeleteFile"
                    (click)="removeSelectedFile(i, 'dischargeSummary')"></button></li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <a class="collapsed card-link" data-toggle="collapse" href="#collapseNine">
        9. Others
      </a>
    </div>
    <div id="collapseNine" class="collapse" data-parent="#accordion">
      <div class="card-body">
        <div class="sum-insured-input">
          <div class="form-group">

            <input id="addAttachment" style="display: none" type="file" (change)="otherDetail($event.target.files)"
              #fileInputNine ng2FileSelect accept="image/x-png,image/jpeg,.png,image/jpg,.zip,.pdf,.doc,.dox,.xls,.xlsx"
              [uploader]="uploader" multiple required>
            <img class="attachment-icon" (click)="fileInputNine.click()">
            <label>Attach Files</label>
            <div class="mt-2">
              <div class="" *ngIf="uploading">
                <span class="spinner-border spinner-border-sm text-info"></span>
                Uploading..
              </div>
              <div id="previouslyUploadedOthers" hidden>
                <label for="text" style="font: bold; color: #438BC9;">Previously Uploaded </label>
                <div class="attachedFiles" *ngFor='let docs of cliamDocuments'>
                  <ng-container *ngIf="docs.documentId==9">
                    <li>{{docs.docDescription}} <button class="btnDeleteFile" id="{{docs.id}}"
                        (click)="deleteDocByClaimDocumentId(docs.id)"></button></li>
                  </ng-container>
                </div>
              </div>
              <div class="attachmentList" *ngFor="let others of otherDetails;  let i = index" [attr.data-index]="i">
                <li>{{others}} <button class="btnDeleteFile" (click)="removeSelectedFile(i, 'other')"></button></li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  </div>
  </li>
  <!--  -->
  </ul>
  <span id="uploadFileError"></span>
  <div class="col text-center mt-4">
    <button class="btn btn-bordered-blue mx-1" aria-label="Close" (click)="upload();">Save</button>
    <button class="btn btn-bordered-blue mx-1" id="submit_btn" aria-label="Close" [disabled]="isMailButton" (click)="senMailOnSubmit()">Submit</button>
  </div>
  </div>
  </div>
  <!-- view card ends -->

  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</Section>
<section class="intimate-successfull" *ngIf="submissionSuccessfull">
  <div class="container">
    <div class="col text-center">
      <!-- <h2 class="done-heading">Registration Done</h2> -->
      <img
        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/done-intimate.jpg">
    </div>
    <center class="sub-title mt-2">
      <p>THANK YOU</p>
    </center>
    <div class="col note text-center">
      <p>Document submitted for claim no. <span class="registrationNo">{{this.intimationNo}}</span>.
      </p>
    </div>
    <div class="col footer-strip text-center">
      <p>For any queries, please reach us at:</p>
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive subnission_image" alt="Securenow">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span> | support@securenow.in</span>
      </p>
    </div>
  </div>
</section>
